import React, { useEffect, useState } from "react";
import { AssetMoveRequestListApi } from "../../services/AssetService";
import { format } from "date-fns";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { Link } from "react-router-dom";
import Pagination from "../Constant/Pagination";
import { Spinner } from "react-bootstrap";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import { CustomTooltip } from "../../components/CustomTooltip";
import AssetMoveRequestActionModal from "../Asset/ActionModal/AssetMoveRequestActionModal";
import { FaInfoCircle } from "react-icons/fa";
const AssetMoveRequest = () => {
  const [selectedData, setselectedData] = useState(null);
  const [actionType, setActionType] = useState("");
  const [moveActionModal, setMoveActionModal] = useState(false);
  const [loading, setLoaing] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });
  const handleToggleMoveActionModal = () => {
    setMoveActionModal(!moveActionModal);
  };
  const getRequestList = () => {
    setLoaing(true);
    AssetMoveRequestListApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoaing(false);
      });
  };
  useEffect(() => {
    getRequestList();
  }, [param]);
 
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleAfterMoveActionSubmit = () => {
    handleToggleMoveActionModal();
    getRequestList();
  };
  return (
    <>
      <div className="mb-3">
        <h2 className="text-primary">Assets Move Requests</h2>
        <ol className="breadcrumb breadcrumb-arrow mb-0">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active">Move Requests</li>
        </ol>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="flex-fill flex-md-grow-0">
            <small>Search here</small>
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>
        <div>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-4">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Asset Number</th>
                    <th>Name</th>
                    <th>From Location</th>
                    <th>Move By</th>
                    <th>Remark</th>
                    <th>Move Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((asset, index) => (
                    <tr key={index}>
                      <td>
                        {/* <Link
                          to={`/asset/${asset?.id}/basic-details`}
                          className="fw-bold text-primary"
                        > */}
                        {asset?.asset?.asset_number || "-"}
                        {/* </Link> */}
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-1 cursor-pointer">
                          <span>{asset?.asset?.name || "-"}</span>
                          <CustomTooltip
                            title={
                              <div>
                                <div>
                                  <strong>Brand:</strong>{" "}
                                  {asset?.asset?.brand || "-"}
                                </div>
                                <div>
                                  <strong>Model No.:</strong>{" "}
                                  {asset?.asset?.model_number || "-"}
                                </div>
                                <div>
                                  <strong>Asset ID:</strong>{" "}
                                  {asset?.asset?.manual_asset_id || "-"}
                                </div>
                                <div>
                                  <strong>Price:</strong>
                                  {`₹${asset?.asset?.purchase_cost}` || "-"}
                                </div>
                              </div>
                            }
                            placement="right"
                          >
                            <span>
                              <FaInfoCircle />
                            </span>
                          </CustomTooltip>
                        </div>
                      </td>
                      <td>{asset?.from_location?.name || "-"}</td>
                      <td>{asset?.requested_by?.name || "-"}</td>
                      <td>{asset?.remarks || "-"}</td>
                      <td>
                        {asset?.requested_at
                          ? format(new Date(asset.requested_at), "dd MMM yyyy")
                          : "-"}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <CustomTooltip title="Accept" placement="top">
                            <span
                              className="btn btn-sm btn-outline-light text-info rounded-2"
                              style={{ padding: "0.3rem" }}
                              onClick={() => {
                                setActionType("accept");
                                setselectedData(asset);
                                handleToggleMoveActionModal();
                              }}
                            >
                              <IoIosCheckmarkCircle
                                className="text-success"
                                size={19}
                              />
                            </span>
                          </CustomTooltip>

                          <CustomTooltip title="Reject" placement="top">
                            <span
                              className="btn btn-sm btn-outline-light text-danger rounded-2"
                              style={{ padding: "0.3rem" }}
                              onClick={() => {
                                setActionType("reject");
                                setselectedData(asset);
                                handleToggleMoveActionModal();
                              }}
                            >
                              <MdCancel className="text-danger" size={19} />
                            </span>
                          </CustomTooltip>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">
              <span>No data found</span>
            </div>
          )}

          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      <AssetMoveRequestActionModal
        actionType={actionType}
        open={moveActionModal}
        onClose={handleToggleMoveActionModal}
        afterSubmit={handleAfterMoveActionSubmit}
        assetData={selectedData}
      />
    </>
  );
};

export default AssetMoveRequest;
